define('ordersDetailOrderCommentsListCommentTagView',[
  'module',
  'marionette',
  'underscore',
  'template!ordersDetailOrderCommentsListCommentTagView'
], function(
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({    
    className: 'comment-tag-view',
    template: Tpl,

    events: {
      'click': 'onClick'
    },
    
    serializeData: function () {          
      return {
        name: this.model.get('name')
      };
    },

    onClick: function(e) {      
      e.stopPropagation();
      this.trigger('remove', this.model);
    }
  });   
});
